import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import Vue from 'vue';
import Router from 'vue-router';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import Gikam from 'gikam';
Vue.use(Router);
var defaultOptions = {
  dsn: null,
  tracingOrigins: ['localhost', 'my-site-url.com', /^\//]
};

var SunwaySentry = /*#__PURE__*/function () {
  function SunwaySentry() {
    _classCallCheck(this, SunwaySentry);
  }

  _createClass(SunwaySentry, null, [{
    key: "init",
    value: function init(options) {
      Gikam.extend(true, defaultOptions, options);
      var dsn = defaultOptions.dsn,
          tracingOrigins = defaultOptions.tracingOrigins;

      if (!dsn) {
        return;
      }

      var router = new Router({
        mode: 'history'
      });
      Sentry.init({
        Vue: Vue,
        dsn: dsn,
        integrations: [new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: tracingOrigins,
          logErrors: true
        })],
        tracesSampleRate: 1.0
      });
    }
  }]);

  return SunwaySentry;
}();

export { SunwaySentry as default };